import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	type LWApiPublicOrderListParamsRaw,
	type LWApiPublicOrderListResultRaw,
} from '@liquidweb-dev/club-sauce/public/order/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const ORDER_LIST_QUERY_KEY = '/order/list';

const useOrderList = (
	params: LWApiPublicOrderListParamsRaw,
	options?: UseQueryOptions<LWApiPublicOrderListResultRaw, ApiErrorI>,
) =>
	useQuery({
		queryKey: [ORDER_LIST_QUERY_KEY, params],
		queryFn: () => api.order.apiRaw.list(params),
		...options,
	});

export default useOrderList;
